import { Resource, Immunization } from '@medplum/fhirtypes'
import { formatDateTime } from '@/utils'

type Props = {
  resource?: Resource
}

const availFields = [
  { code: 'vaccine', title: 'Vaccine' },
  { code: 'route', title: 'Route' },
  { code: 'date', title: 'Date' },
  { code: 'status', title: 'Status' },
  { code: 'dose', title: 'Dose' },
  { code: 'instruction', title: 'Instruction' },
  { code: 'doctor', title: 'Doctor' },
]

const renderColumn = (resource: Immunization, itemCode: string) => {
  switch (itemCode) {
    case 'vaccine': {
      const main = resource.vaccineCode?.text || resource.vaccineCode?.coding?.[0]?.display || ''
      const lot = resource.lotNumber ? `Lot #: ${resource.lotNumber}` : ''
      const manufacturer = resource.manufacturer?.display || resource.manufacturer?.reference || ''
      const lines = [main]
      if (lot) lines.push(lot)
      if (manufacturer) lines.push(`Manufacturer: ${manufacturer}`)
      return (
        <div>
          {lines.map((l, i) => (
            <div key={i}>{l}</div>
          ))}
        </div>
      )
    }
    case 'route':
      return resource.route?.coding?.[0]?.display || resource.route?.coding?.[0]?.code || ''
    case 'date': {
      const date = resource.occurrenceDateTime || resource.recorded
      if (!date) return ''
      return formatDateTime(date)
    }
    case 'status':
      if (
        resource.status === 'not-done' ||
        resource.extension?.some((e) => e.url.includes('notGiven') && e.valueBoolean)
      ) {
        return 'refused'
      }
      return resource.status || ''
    case 'dose':
      if (resource.doseQuantity && resource.doseQuantity.value) {
        return `${resource.doseQuantity.value} ${resource.doseQuantity.unit || ''}`.trim()
      }
      return ''
    case 'instruction':
      return ''
    case 'doctor':
      if (resource.performer?.length && resource.performer[0].actor?.display) {
        return resource.performer[0].actor.display
      }
      return ''
    default:
      return ''
  }
}

export function Immunizations({ resource }: Props) {
  const immunization = resource as Immunization

  if (!immunization) {
    return null
  }

  return (
    <div className="border-b-1 border-b-gray-200 pb-2">
      <table className="text-base">
        <tbody>
          {availFields.map((item) => (
            <tr>
              <td className="pr-4 text-right align-top whitespace-nowrap">
                <strong>{item.title}:</strong>
              </td>
              <td className="flex gap-2 align-top whitespace-pre-wrap">
                <div>{renderColumn(immunization, item.code)}</div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
